/**
 * Recommendations type.
 *
 * * [slot](https://findify.readme.io/v3/reference#recommendation-api-slot) - Get recommendation using pre-configured slot.
 * * [newest](https://findify.readme.io/v3/reference#recommendation-api-newest) - Provides latest products in your store.
 * * [trending](https://findify.readme.io/v3/reference#recommendation-api-trending) - Provides trending products in your store.
 *   The trending information is calculated based on user behaviour.
 * * [recently-viewed](https://findify.readme.io/v3/reference#recommendation-api-viewed-latest) - Provides products recently viewed by the current user.
 * * [also-viewed](https://findify.readme.io/v3/reference#recommendation-api-item-viewed-viewed) - Provides 'users who viewed this product, also viewed these products' recommendation.
 * * [also-bought](https://findify.readme.io/v3/reference#recommendation-api-item-viewed-bought) - Provides 'users who viewed this product, also bought these products' recommendation.
 * * [frequently-purchased-together](https://findify.readme.io/v3/reference#recommendation-api-item-bought-bought) - Provides 'frequently purchased together' recommendation.
 * * [featured](https://findify.readme.io/v3/reference#recommendation-api-featured) - Provides featured products in your store.
 */
export var Type;
(function (Type) {
    Type["Slot"] = "slot";
    Type["Newest"] = "newest";
    Type["Trending"] = "trending";
    Type["RecentlyViewed"] = "latest";
    Type["AlsoViewed"] = "viewed";
    Type["AlsoBought"] = "bought";
    Type["FrequentlyPurchasedTogether"] = "purchasedTogether";
    Type["Featured"] = "featured";
})(Type || (Type = {}));
